<template>
  <AuthPageContainer>
    <template #header>
      {{ $t("register.title") }}
    </template>

    <form
      @submit.prevent="onRegister"
      class="w-100 gap-row-lg"
      v-if="stage == 0"
    >
      <div class="gap-row-xs w-100">
        <BaseInput
          v-model="register_data.name"
          :placeholder="$t('register.name_ph')"
          fullWidth
          :valid="validation.name || !!register_data.name"
        />

        <BaseInput
          v-model="register_data.email"
          @keyp="validation.email = true"
          :placeholder="$t('register.email_ph')"
          :valid="validation.email || !!register_data.email"
          fullWidth
          type="email"
        />

        <PhoneInput
          v-model="register_data.phone"
          :placeholder="$t('register.phone_ph')"
          :class="{invalid: !validation.phone && !register_data.phone}"
          fullWidth
        />

        <BaseInput
          v-model="register_data.cafe"
          @keyp="validation.cafe = true"
          :placeholder="$t('register.cafe_ph')"
          :valid="validation.cafe || !!register_data.cafe"
          fullWidth
        />

        <BaseInput
          :placeholder="$t('register.address_ph')"
          :value="register_data.address"
          :valid="validation.address || !!register_data.address"
          inputId="gmapField"
          fullWidth
        />

        <div class="gap-column-xs w-100">
          <BaseCheckbox
            class="register-terms-checkbox"
            :class="{
              'invalid-box': !validation.terms
            }"
            v-model="terms_agreed"
          />

          <span
            class="qrw-paragraph-xs"
            :class="{
              'v1-grey-6-color': !terms_agreed,
              'v1-grey-10-color': terms_agreed,
            }"
            @click="terms_agreed = !terms_agreed"
          >
            {{ $t("register.terms_agree") }}
          </span>
        </div>
      </div>

      <div class="gap-row-sm w-100">
        <BaseDivider color="v1-grey-4" />

        <div class="gap-row-xs w-100">
          <BaseButton
            class="w-100"
            variant="primary"
            color="green-5"
            type="submit"
            :class="{
              disabled: !isFormValid
            }"
            :busy="busy"
            size="lg"
          >
            {{ $t("register.action") }}
          </BaseButton>
          <BaseButton
            class="w-100"
            variant="tertiary"
            type="button"
            @click="$router.push('/login')"
            color="green-5"
            size="lg"
          >
            {{ $t("login.login") }}
          </BaseButton>
        </div>

        <BaseTextDivider color="v1-grey-4" :info="$t('register.or')" />
        <a href="/api/poster/start">
          <BaseButton
            class="gap-column-1xs w-100"
            type="button"
            @click="toPoster"
            size="lg"
            variant="primary"
            color="v1-grey-10"
          >
            <img
              src="https://cdn.qrwaiter.com.ua/assets/integrations/poster.jpg"
              class="poster-logo"
            />
            {{ $t("register.via_poster") }}
          </BaseButton>
        </a>
      </div>
    </form>

    <div class="register-success gap-row-md" v-else-if="stage == 1">
      <img src="../assets/hero-wine.svg" />

      <BaseDivider color="v1-grey-4" />

      <div
        class="v1-grey-10-color qrw-heading-xs mail-sent"
        v-html="$t('register.mail_sent', register_data)"
      ></div>

      <BaseButton
        variant="tertiary"
        color="orange-4"
        @click="stage = 0"
        size="lg"
      >
        {{ $t("register.change_mail") }}
      </BaseButton>
    </div>

    <img
      src="/icons/quickstart-panda.svg"
      class="register-panda"
      v-if="stage == 0"
    />
  </AuthPageContainer>
</template>

<script>
import AuthPageContainer from "@/components/AuthPageContainer.vue";

import GoogleMapsService from "@/services/googlemaps";

import JoinAPI from "@/api/join";

export default {
  metaInfo() {
    return {
      title: "Register - QRWaiter",
    };
  },
  data() {
    return {
      register_data: {
        cafe: null,
        address: null,
        name: null,
        phone: null,
        email: null,
        category: "cafe",
        city: null,
        address_location: null,
        country: null,
        language: "ua",
        role: "admin",
        saleagent_id: null,
        manager_link: null,
      },

      validation: {
        phone: true,
        name: true,
        email: true,
        address: true,
        cafe: true,
        terms: true
      },

      stage: 0,

      busy: false,

      terms_agreed: false,

      register_error: null,

      autocomplete_object: null,
    };
  },
  methods: {
    initAddressField() {
      const element = document.getElementById("gmapField");

      console.log(`gmapField: `, element);

      this.autocomplete_object = GoogleMapsService.initAutocompleteWidget(
        element,
        this.onPlaceChanged
      );
    },
    onPlaceChanged() {
      const result = GoogleMapsService.decodeAutocompletePlace(
        this.autocomplete_object
      );

      this.register_data.address = result.address;
      this.register_data.city = result.city;
      this.register_data.address_location = result.location;
      this.register_data.country = result.country;

      console.log(result);
    },
    onRegister() {
      if (this.busy) return;

      this.validation = {
        phone: true,
        name: true,
        email: true,
        address: true,
        cafe: true,
        terms: true
      };

      if (!this.register_data.name) {
        this.validation.name = false;
      }

      if (!this.register_data.email) {
        this.validation.email = false;
      }

      if (!this.register_data.phone) {
        this.validation.phone = false;
      }

      if (!this.register_data.address) {
        this.validation.address = false;
      }

      if (!this.register_data.cafe) {
        this.validation.cafe = false;
      }

      if (!this.register_data.phone) {
        this.validation.phone = false;
      }

      if (!this.terms_agreed) {
        this.validation.terms = false;
       }

      if (!this.validation.phone || !this.validation.name || !this.validation.cafe || !this.validation.email || !this.validation.address || !this.validation.terms) {
        return;
      }

      this.busy = true;

      this.register_data.manager_link = this.$route.query.slid || null;

      JoinAPI.apply(this.register_data)
        .then(() => {
          this.stage = 1;
          this.busy = false;

          window.fbq("track", "Lead");
        })
        .catch((error) => {
          this.register_error = error;
          this.busy = false;
        });
    },
  },
  computed: {
    isFormValid() {
      return (
        this.register_data.name &&
        this.register_data.cafe &&
        this.register_data.address &&
        this.terms_agreed &&
        this.register_data.email
      );
    },
  },
  mounted() {
    window.document.body.style.backgroundColor = "var(--v1-grey-1-color)";

    this.$nextTick(() => {
      setTimeout(() => {
        this.initAddressField();
      }, 500);
    });

    this.$store.dispatch('bootIntercom');
  },
  beforeDestroy() {
    window.document.body.style.backgroundColor = "var(--black-color)";
  },
  components: {
    AuthPageContainer,
  },
};
</script>

<style scoped>
.register-wrapper {
  overflow: auto;
  text-align: center;
  padding: 80px 0;
  margin: auto;
  background: var(--v1-grey-1-color);
  display: flex;
  color: var(--black-color);
}

.register-wrapper.fix-width {
  width: 333px;
}

.register-wrapper img.logo {
  width: 32px;
  height: auto;
  display: block;
  margin: 0 auto;
}

h4 {
  padding-top: 24px;
  color: var(--v1-grey-7-color);
  font-weight: bold;
}

h2 {
  padding-top: 70px;
}

h5 {
  padding-top: 16px;
}

.register-input {
  margin-top: 16px;
}

.register-line {
  margin: 32px 0;
  color: var(--v1-grey-6-color);
}

.register-line.fix-width {
  width: 472px;
  margin: 32px auto;
}

.register-btn {
  width: 100%;
}

.register-link {
  display: block;
  cursor: pointer;
  padding-top: 24px;
  color: var(--green-6-color);
}

.register-phone-input {
  margin-top: 32px;
}

.register-phone-input ::v-deep .select-container {
  width: 106px !important;
}

.register-phone-input ::v-deep .input-wrapper {
  width: 100% !important;
}

.phone-inputs {
  display: flex;
  width: 184px;
  justify-content: space-between;
  margin: 16px auto 0;
}

.register-phone-field {
  width: 40px;
}

.register-phone-field::v-deep input {
  text-align: center;
}

img.hero {
  margin-top: 32px;
}

.approve-register {
  width: 366px;
  margin: 0 auto;
  padding: 64px 23px;
}

.pass-control {
  display: flex;
  margin-top: 16px;
}

.pass-control .line:first-child,
.pass-control .line:last-child {
  margin: 0;
}

.pass-control .line {
  width: -webkit-fill-available;
  margin: 0 8px;
  border-radius: 8px;
  height: 2px;
  background: var(--red-4-color);
}

.pass-control .line.weak {
  background: var(--red-4-color);
}

.pass-control .line.good {
  background: var(--orange-4-color);
}

.pass-control .line.perfect {
  background: var(--green-6-color);
}

.control-text {
  padding-top: 8px;
  display: block;
}

/*  */
.register-panda {
  position: fixed;
  bottom: -4px;
  left: -4px;
  z-index: 32;
}

.register-success {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.register-success img {
  display: block;
  width: 240px;
  height: 240px;
  max-width: 240px;
  min-height: 240px;
  max-height: 240px;
}

.mail-sent {
  min-width: 572px;
}

a {
  text-decoration: none;
  display: block;
}

.poster-logo {
  border-radius: 2px;
  object-fit: cover;
  width: 16px;
  height: 16px;
  max-width: 16px;
  max-height: 16px;
  min-width: 16px;
  min-height: 16px;
  display: block;
}

.disabled {
  opacity: 0.64;
}

.invalid {
  border: 1px solid var(--red-4-color);
}
</style>

<style>
.register-terms-checkbox.invalid-box .checkbox-item {
  border: 1px solid var(--red-4-color);
}
</style>